export enum DowntimeAnalyticsEventName {
  UserEntersDowntimeDashboard = 'userEntersDowntimeDashboard',
  UserClicksOnRcfa = 'userClicksOnRcfa',
  UserSet1LevelGrouping = 'userSet1LevelGrouping',
  UserSet1LevelSorting = 'userSet1LevelSorting',
  UserClicksOn1LevelStoppagesGraph = 'userClicksOn1LevelStoppagesGraph',
  UserOpenStoppagesToAmendList = 'userOpenStoppagesToAmendList',
  UserOpenStoppageToAmendForm = 'userOpenStoppageToAmendForm',
  UserSkipStoppageWithMissingData = 'userSkipStoppageWithMissingData',
  UserAmendStoppage = 'userAmendStoppage',
  UserSet2LevelGrouping = 'userSet2LevelGrouping',
  UserSet2LevelSorting = 'userSet2LevelSorting',
  UserAdjusts2LevelFilter = 'userAdjusts2LevelFilter',
  UserClicksOn2LevelStoppagesGraphBar = 'userClicksOn2LevelStoppagesGraphBar',
  UserSet3LevelSorting = 'userSet3LevelSorting',
  UserAdjusts3LevelFilter = 'userAdjusts3LevelFilter',
  UserAdjusts4LevelFilter = 'userAdjusts4LevelFilter',
  UserAdjustDescriptionColumn = 'userAdjustDescriptionColumn',
  UserClicksOn3LevelStoppagesGraphBar = 'userClicksOn3LevelStoppagesGraphBar',
  UserGoesBackTo3Level = 'userGoesBackTo3Level',
  UserGoesBackTo2Level = 'userGoesBackTo2Level',
  UserGoesBackTo1Level = 'userGoesBackTo1Level'
}
